<template>
    <div class="materialPlan-box">
        <HeaderNav
            header-title="运输单列表"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <!-- <div class="search-con">
            <van-search placeholder="请输入搜索关键词"></van-search>
        </div> -->
        <div class="warpper">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                v-if="total"
            >
                <div
                    class="materialPlan-item saved"
                    v-for="(item) in historyOrder"
                    :key="item.pcb_number"
                    @click="toElectronicTicket(item)"
                >
                    <div class="status-tag" v-if="item.driver_eva" @click.stop="toEvaluate(item, 'over')">
                        已评价
                    </div>
                    <div class="status-tag" v-else>
                        未评价
                    </div>
                    <ul>
                        <li class="tit">
                            <span class="pre-icon materialPlan01"></span>
                            <span class="info">运单编号：{{ item.pcb_number }}</span>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan02"></span>
                            <span class="info">发货方量:{{ item.volume }}m³</span>
                        </li>
                        <li>
                            <van-row>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan03"></span>
                                    <span class="info">过磅方量:{{ item.weigh_volume }}m³</span>
                                </van-col>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan04"></span>
                                    <span class="info">交付方量:{{ item.unload_volume }}m³</span>
                                </van-col>
                            </van-row>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan05"></span>
                            <span class="info">完成时间：{{ item.unload_over_time }}</span>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan06"></span>
                            <span class="info">工程名称：{{ item.project_name }}</span>
                        </li>
                        <li class="last">
                            <span class="pre-icon materialPlan07"></span>
                            <span class="info">工程位置：{{ item.project_address }}</span>
                        </li>
                    </ul>
                    <div class="handle-btns">
                        <!-- <div class="sign-btn surplus-btn" v-if="item.is_surplus===0" @click.stop="surplus(item)">
                            剩退灰
                        </div> v-if="!item.driver_eva"-->
                        <div class="sign-btn" v-if="!item.driver_eva" @click.stop="toEvaluate(item, 'new')">
                            交付评价
                        </div>
                    </div>
                </div>
            </van-list>
            <div class="no-data" v-else></div>
        </div>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            historyOrder: [], // 历史运输单
            pagetion: {
                pageindex: 0,
                pagesize: 3,
            },
            loading: false,
            finished: false,
            total: true,
        };
    },
    methods: {
        onLoad() {
            this.pagetion.pageindex++;
            this.MobilePhone = this.$takeTokenParameters('MobilePhone');
            // 待修改 type 0 历史，1 当天  分页
            this.$axios
                .get('/interfaceApi/production/productpcb/page_driver?phone='
                + this.MobilePhone + '&pageindex=' + this.pagetion.pageindex + '&pagesize=' + this.pagetion.pagesize + '&type=0')
                .then(res => {
                    if (res) {
                        this.loading = false;
                        if (res.page.total) {
                            this.total = true;
                            this.historyOrder = this.historyOrder.concat(res.page.rows);
                            if (this.historyOrder.length >= res.page.total) {
                                this.finished = true;
                            }
                        } else {
                            this.finished = true;
                            this.total = false;
                        }
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取司机运输单列表
        getDriver() {
            this.MobilePhone = this.$takeTokenParameters('MobilePhone');
            // 待修改 type 0 历史，1 当天  分页
            this.$axios
                .get('/interfaceApi/production/productpcb/page_driver?phone='
                + this.MobilePhone + '&pageindex=' + this.pagetion.pageindex + '&pagesize=' + this.pagetion.pagesize + '&type=0')
                .then(res => {
                    if (res) {
                        this.historyOrder = res.page.rows;
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 评价
        toEvaluate(data, type) {
            this.$router.isBack = 2;
            if (type === 'new') {
                this.$router.push({ name: 'newTransSheet', params: { pcb_number: data.pcb_number } });
            } else {
                this.$router.push({ name: 'transSheetInfo', params: { pcb_number: data.pcb_number } });
            }

        },
        // 展示电子运单
        toElectronicTicket(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'electronicTicket', params: { pcb_number: data.pcb_number } });
        },

    },
    created() {
        // this.getDriver();
    },
};
</script>

<style lang="stylus">
.materialPlan-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .newPlan
        position fixed
        right 20rpx
        top 10rpx
        z-index 1000
        color #fff
    .search-con
        .van-search
            background #F0F0F0!important
    .warpper
        height 100%
        background #F0F0F0
        overflow-y auto
        overflow-x hidden
        padding 0 12rpx 12rpx 12rpx
        .materialPlan-item
            width 100%
            background #ffffff
            margin-top 15rpx
            position relative
            overflow hidden
            padding 10rpx 10rpx 25rpx 10rpx
            color #666666
            font-size 14rpx
            .status-tag
                position absolute
                top 10rpx
                right 6rpx
                color #00A84B
                font-size 14rpx
            li
                overflow hidden
                margin-bottom 10rpx
                line-height 22rpx
                .pre-icon
                    width 18rpx
                    height 18rpx
                    display inline-block
                    margin 0 10rpx 0 0
                    vertical-align middle
                    &:before
                        content ' '
                        width 16rpx
                        height 16rpx
                        display inline-block
                        background-repeat no-repeat
                        background-size 100% 100%
                    &.materialPlan01
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_3.png)
                    &.materialPlan02
                        &:before
                            background-image url(./../../../assets/images/icons/icon_30.png)
                    &.materialPlan03
                        &:before
                            background-image url(./../../../assets/images/icons/icon_6.png)
                    &.materialPlan04
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_1.png)
                    &.materialPlan05
                        &:before
                            background-image url(./../../../assets/images/icons/icon_32.png)
                    &.materialPlan06
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_7.png)
                    &.materialPlan07
                        &:before
                            background-image url(./../../../assets/images/icons/icon_3.png)
                    &.materialPlan08
                        &:before
                            background-image url(./../../../assets/images/icons/icon_16.png)
                .info
                    width calc(100% - 26rpx)
                &.tit
                    font-size 14rpx
                    font-weight 600
                    color #061F3E
                    .icondanjubianhao
                        font-size 18rpx
                        margin 3rpx 8rpx 0 0
            &.saved
                .tit
                    .icondanjubianhao
                        color #0189FC
                .corner-marker
                    background #0189FC
            .handle-btns
                position absolute
                right 10rpx
                bottom 10rpx
                .sign-btn
                    float right
                    width 70rpx;
                    height 25rpx;
                    border 1px solid #5588F1
                    border-radius 4rpx;
                    text-align center
                    color #5588F1
                    font-size 12rpx
                    line-height 25rpx
                .surplus-btn
                    float right
                    height 25rpx;
                    padding 0 6rpx
                    margin-left 10rpx
                    border 1px solid #fa8435
                    color #fa8435
</style>